__turbopack_context__.v({
  "content_info": "_7bmr6a_content_info",
  "fade-in": "_7bmr6a_fade-in",
  "icon": "_7bmr6a_icon",
  "image": "_7bmr6a_image",
  "info": "_7bmr6a_info",
  "input": "_7bmr6a_input",
  "label": "_7bmr6a_label",
});
